<template>
  <v-container
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <!-- <v-flex
        xs12
        sm6
        lg2>
        <material-stats-card
          v-model="summaryCaseName"
          style="margin-bottom:-20px !important;"
          color="purple"
          icon="mdi-folder-open"
          title="案名"/>
      </v-flex> -->
      <v-flex
        xs12
        sm6
        lg8>
        <v-layout wrap>
          <v-flex
            xs12
            sm6
            lg4>
            <material-stats-card
              :value="responseAreaData.modelName"
              style="margin-bottom:-20px !important;margin-top:28px !important;"
              color="purple"
              icon="mdi-television-guide"
              title="機種名稱"/>
          </v-flex>
          <v-flex
            xs12
            sm6
            lg4>
            <material-stats-card
              :value="responseAreaData.deviceIsn"
              style="margin-bottom:0px !important;margin-top:28px !important;"
              color="deep-purple"
              icon="mdi-nut"
              title="ASUS PN"/>
          </v-flex>
          <!-- <v-flex
        xs12
        sm6
        lg1>
        <material-stats-card
          :value="responseAreaData.processType"
          class="v-offset-none"
          style="margin-bottom:0px !important;"
          color="deep-purple"
          icon="mdi-nut"
          title="製程別"/>
      </v-flex>
          <v-flex
            v-if="showStage"
            xs12
            sm6
            lg1>
            <material-stats-card
              :value="summaryStage || 'All'"
              class="v-offset-none"
              style="margin-bottom:0px !important;"
              color="deep-purple"
              icon="mdi-layers"
              title="Stage"/>
          </v-flex> -->
          <v-flex
            xs12
            sm6
            lg4>
            <material-stats-card
              :value="responseAreaData.vendor"
              style="margin-bottom:-20px !important;margin-top:28px !important;"
              color="indigo"
              icon="mdi-factory"
              title="供應商"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg4>
        <!-- <v-btn
          class="mx-0 font-weight-light"
          color="primary"
          @click="doSubmit()"
        >
          <v-icon class="mr-2">mdi-chart-bar</v-icon>當日統計
        </v-btn> -->
        <material-stats-card
          :value="responseAreaData.launchDate + ' ' + responseAreaData.launchTime"
          style="margin-bottom:-20px !important;margin-top:25px !important;padding-right: 125px;!important;"
          color="light-blue"
          icon="mdi-clock"
          title="測試時間"/>
        <router-link
          :to="statisticLink"
          target="_blank">
          <v-btn
            style="position: absolute;right: 27px;top: 45px;"
            class="mx-0 px-3 font-weight-light"
            color="primary">
            <v-icon class="mr-2">mdi-chart-bar</v-icon>當日統計
          </v-btn>
        </router-link>
      </v-flex>
      <v-flex
        xs12
        lg3>
        <v-layout wrap>
          <v-flex
            xs12>
            <material-stats-card
              :value="responseAreaData.fixtureId"
              style="margin-bottom:-20px !important;margin-top:5px !important;margin-right: 5px!important;width: calc(((100% - 120px) / 3) + 109px);float: left;"
              color="blue-grey"
              icon="mdi-factory"
              title="機台號"/>
            <material-stats-card
              :value="responseAreaData.stationId"
              class="v-offset-none"
              style="margin-bottom:-20px !important;margin-top:5px !important;margin-right: 5px!important;width: calc((100% - 120px) / 3);float: left;"
              color="cyan"
              icon="mdi-check"
              title="站別"/>
            <material-stats-card
              :value="responseAreaData.roomTemperature"
              class="v-offset-none"
              style="margin-bottom:-20px !important;margin-top:5px !important;width: calc((100% - 120px) / 3);float: left;"
              color="cyan"
              icon="mdi-check"
              title="室溫"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        lg9>
        <v-layout wrap>
          <v-flex
            xs12
            lg6>
            <material-stats-card
              :value="responseAreaData.barcode"
              style="margin-bottom:-20px !important;margin-top:5px !important;"
              color="grey"
              icon="mdi-barcode"
              title="測試料號條碼號"/>
          </v-flex>
          <v-flex
            xs12
            sm8
            lg6>
            <material-stats-card
              :value="responseAreaData.errorMessage || 'pass'"
              :color="responseAreaData.color"
              :class="responseAreaData.warningColor || 'green'"
              :icon="responseAreaData.icon || 'mdi-check'"
              class="title-color"
              style="margin-bottom:-20px !important;margin-top:5px !important;margin-right: 5px!important;width: calc(((100% - 115px) * 0.75) + 109px);float: left;"
              title="ERROR CODE"/>
            <material-stats-card
              :value="responseAreaData.testResult"
              :color="responseAreaData.color"
              :class="responseAreaData.warningColor || 'green'"
              :icon="responseAreaData.icon || 'mdi-check'"
              class="title-color v-offset-none"
              style="margin-bottom:-20px !important;margin-top:5px !important;width: calc((100% - 115px) * 0.25);float: left;"
              title="測試結果"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        md12
      >
        <material-card
          class="card-shrink v-card__first"
          color="deep-orange"
          title="熱測數據清單"
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            multi-sort
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <!-- <td
                class="td-check"
                style="position: relative;">
                <v-checkbox
                  v-model="checkList"
                  :value="item.SN"
                  class="mx-2"
                  style="position: absolute;top: 10px;"
                  color="orange"
                  label=""/>
              </td> -->
              <td>{{ item.Type }}</td>
              <td>{{ item.Rspec }}</td>
              <td class="text-xs-right">{{ item.R }}</td>
              <td class="text-xs-right">{{ item.th1 }}</td>
              <td class="text-xs-right">{{ item.th2 }}</td>
              <td class="text-xs-right">{{ item.cpuPower }}</td>
              <td class="text-xs-right">{{ item.vgaPower }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        class="v-flex__first"
        xs12
        md6
      >
        <material-card
          class="v-flex v-c3-chart"
          color="green"
        >
          <div class="w-100 chart-btn c3-chart">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              當日數據分佈_DT1
              <div class="float-right">
                <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
                表單體數據的分佈落點</div>
            </material-notification>
            <div
              ref="chartXScrollDt1"
              class="chart-x-scroll"
              :style="chartNeedScroll('dt1') ? 'overflow-x: auto;' : 'overflow-x: hidden;'"
            >
              <div
                class="chart-x-inner"
                :style="chartInnerStyle('dt1')"
              >
                <vue-c3 :handler="chartState.dt1.handler"/>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>
      <v-flex
        class="v-flex__first"
        xs12
        md6
      >
        <material-card
          class="v-flex v-c3-chart"
          color="green"
        >
          <div class="w-100 chart-btn c3-chart">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              當日數據分佈_DT2
              <div class="float-right">
                <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
                表單體數據的分佈落點</div>
            </material-notification>
            <div
              ref="chartXScrollDt2"
              class="chart-x-scroll"
              :style="chartNeedScroll('dt2') ? 'overflow-x: auto;' : 'overflow-x: hidden;'"
            >
              <div
                class="chart-x-inner"
                :style="chartInnerStyle('dt2')"
              >
                <vue-c3 :handler="chartState.dt2.handler"/>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>
      <v-flex
        v-if="showDt3Chart"
        class="v-flex__first"
        xs12
        md6
      >
        <material-card
          class="v-flex v-c3-chart"
          color="green"
        >
          <div class="w-100 chart-btn c3-chart">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              當日數據分佈_DT3
              <div class="float-right">
                <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
                表單體數據的分佈落點</div>
            </material-notification>
            <div
              ref="chartXScrollDt3"
              class="chart-x-scroll"
              :style="chartNeedScroll('dt3') ? 'overflow-x: auto;' : 'overflow-x: hidden;'"
            >
              <div
                class="chart-x-inner"
                :style="chartInnerStyle('dt3')"
              >
                <vue-c3 :handler="chartState.dt3.handler"/>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

function createChartState () {
  return {
    summaryRange: '0.1',
    rangeIndex: 0,
    rangeMin: 0,
    rangeMax: 9999,
    rangeCount: 1,
    barXaxisName: [],
    barXaxisValue: [],
    viewportWidth: 0,
    handler: new Vue()
  }
}

const CHART_SCROLL_REF = {
  dt1: 'chartXScrollDt1',
  dt2: 'chartXScrollDt2',
  dt3: 'chartXScrollDt3'
}

export default {
  name: 'CTQThermalPerformanceSingleInfo',
  components: {
    VueC3
  },
  data () {
    return {
      startdate: '2018-04-01',
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      summaryPk: '',
      summaryStationId: '',
      summaryStage: 'PL2',
      chartState: {
        dt1: createChartState(),
        dt2: createChartState(),
        dt3: createChartState()
      },
      responseAreaData: {
        launchDate: '',
        launchTime: {
          hour: 0,
          minute: 0,
          second: 0,
          nano: 0
        },
        deviceIsn: '',
        modelName: '',
        vendor: '',
        vendorPk: 0,
        processType: '',
        fixtureId: '',
        stationId: 0,
        roomTemperature: 0,
        barcode: '',
        testResult: '',
        errorMessage: '',
        dt1Spec: 0,
        dt1: 0,
        dt2Spec: 0,
        dt2: 0,
        dt3Spec: 0,
        dt3: 0,
        cpuPower: 0,
        vgaPower: 0,
        dt1List: [],
        dt2List: [],
        dt3List: []
      },
      pagination: {
        sortBy: 'TotalFailRate', // The field that you're sorting by
        descending: true
      },
      headers: [
        {
          sortable: false,
          text: '',
          value: 'Type'
        },
        {
          sortable: true,
          text: 'SPEC',
          value: 'Rspec'
        },
        {
          sortable: true,
          text: '實測值',
          value: 'R',
          align: 'right'
        },
        {
          sortable: true,
          text: 'TH1',
          value: 'th1',
          align: 'right'
        },
        {
          sortable: true,
          text: 'TH2',
          value: 'th2',
          align: 'right'
        },
        {
          sortable: true,
          text: 'CPU實際功率',
          value: 'cpuPower',
          align: 'right'
        },
        {
          sortable: true,
          text: 'VGA實際功率',
          value: 'vgaPower',
          align: 'right'
        }
      ],
      items: []
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    showDt3Chart () {
      return this.responseAreaData.processType === 'VC'
    },
    showStage () {
      const processType = this.responseAreaData.processType || this.$route.query.processType
      return processType === 'VC' && this.summaryStage !== ''
    },
    statisticLink () {
      const data = this.responseAreaData
      const query = {
        deviceIsn: data.deviceIsn,
        modelname: data.modelName,
        date: data.launchDate,
        vendorpk: data.vendorPk,
        vendor: data.vendor,
        processType: data.processType
      }
      if (data.processType === 'VC' && this.summaryStage) {
        query.stage = this.summaryStage
      }
      return {
        path: '/thermalModule/pl2/vcTestDataStatistc',
        query
      }
    }
  },
  watch: {
    summaryDate (val) {
      this.summaryDateMenu = false
    },
    shrink () {
      this.refreshAllCharts()
    }
  },
  mounted () {
    this._onChartResize = () => {
      this.refreshAllCharts()
    }
    window.addEventListener('resize', this._onChartResize)
    this.$store.dispatch('getAuthorize', '/thermalModule/pl2/vcSingleTestDataInfo')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.pk) {
            this.summaryPk = this.$route.params.pk
          }
          if (this.$route.query.stationId != null && this.$route.query.stationId !== '') {
            this.summaryStationId = this.$route.query.stationId
          }
          if (this.$route.query.stage != null && this.$route.query.stage !== '') {
            this.summaryStage = this.$route.query.stage
          }
          this.doSubmit()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  beforeDestroy () {
    if (this._onChartResize) {
      window.removeEventListener('resize', this._onChartResize)
    }
  },
  methods: {
    formatDecimal3 (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const n = Number(value)
      if (!isFinite(n)) {
        return value
      }
      return n.toFixed(3)
    },
    specText (label, spec) {
      const formatted = this.formatDecimal3(spec)
      return formatted === '' ? '' : (label + ' <=+- ' + formatted)
    },
    buildThermalItems (data) {
      const th1 = this.formatDecimal3(data.th1)
      const th2 = this.formatDecimal3(data.th2)
      const cpuPower = this.formatDecimal3(data.cpuPower)
      const vgaPower = this.formatDecimal3(data.vgaPower)
      const items = [
        {
          Type: 'DT1',
          Rspec: this.specText('DT1', data.dt1Spec),
          R: this.formatDecimal3(data.dt1),
          th1,
          th2,
          cpuPower,
          vgaPower
        },
        {
          Type: 'DT2',
          Rspec: this.specText('DT2', data.dt2Spec),
          R: this.formatDecimal3(data.dt2),
          th1,
          th2,
          cpuPower,
          vgaPower
        }
      ]
      if (data.processType === 'VC' || data.dt3 != null || data.dt3Spec != null) {
        items.push({
          Type: 'DT3',
          Rspec: this.specText('DT3', data.dt3Spec),
          R: this.formatDecimal3(data.dt3),
          th1,
          th2,
          cpuPower,
          vgaPower
        })
      }
      return items
    },
    normalizeResponseData (data) {
      const next = Object.assign({}, data)
      next.dt1List = next.dt1List || next.cpuRList || []
      next.dt2List = next.dt2List || next.vgaRList || []
      next.dt3List = next.dt3List || []
      if (next.dt1 == null && next.cpuR != null) next.dt1 = next.cpuR
      if (next.dt2 == null && next.vgaR != null) next.dt2 = next.vgaR
      return next
    },
    itemChartValue (item) {
      if (item != null && typeof item === 'object') {
        if (item.value != null && item.value !== '') return item.value
        if (item.Value != null && item.Value !== '') return item.Value
        return null
      }
      return item
    },
    chartValueList (key) {
      const data = this.responseAreaData || {}
      let list = []
      if (key === 'dt1') list = data.dt1List || data.cpuRList || []
      else if (key === 'dt2') list = data.dt2List || data.vgaRList || []
      else list = data.dt3List || []
      const values = []
      ;(list || []).forEach((item) => {
        const value = this.itemChartValue(item)
        if (isFinite(Number(value))) {
          values.push(Number(value))
        }
      })
      return values
    },
    chartCurrentValue (key) {
      const data = this.responseAreaData || {}
      if (key === 'dt1') return data.dt1 != null ? data.dt1 : data.cpuR
      if (key === 'dt2') return data.dt2 != null ? data.dt2 : data.vgaR
      return data.dt3
    },
    chartCategoryCount (key) {
      const names = (this.chartState[key] && this.chartState[key].barXaxisName) || []
      return Math.max(0, names.length - 1)
    },
    chartNeedScroll (key) {
      return this.chartCategoryCount(key) > 25
    },
    chartBarWidth (key) {
      if (!this.chartNeedScroll(key)) return undefined
      const viewportWidth = this.chartState[key].viewportWidth
      const count = this.chartCategoryCount(key)
      if (viewportWidth > 0) {
        return Math.round(viewportWidth * count / 25)
      }
      return count * 80
    },
    chartInnerStyle (key) {
      const width = this.chartBarWidth(key)
      if (this.chartNeedScroll(key) && width) {
        return {
          width: width + 'px',
          minWidth: width + 'px'
        }
      }
      return { width: '100%' }
    },
    barChartOptions (key) {
      const state = this.chartState[key]
      return {
        data: {
          x: 'x',
          columns: [
            state.barXaxisName,
            state.barXaxisValue
          ],
          labels: {},
          type: 'bar',
          axes: {
            R: 'y'
          },
          color: (color, d) => {
            return d.index === state.rangeIndex ? '#ffa500' : color
          }
        },
        axis: {
          x: {
            type: 'category',
            tick: {
              rotate: -45,
              multiline: false
            },
            label: {
              text: '溫差',
              position: 'outer-center'
            }
          },
          y: {
            label: {
              text: '數量',
              position: 'outer-middle'
            }
          },
          y2: {}
        },
        tooltip: {
          format: {
            title: (d) => {
              if (state.rangeIndex === d) {
                return `★ ${state.barXaxisName[d + 1]} ★`
              }
              return `${state.barXaxisName[d + 1]}`
            },
            value: (value) => {
              return `${value}`
            }
          }
        },
        grid: {
          x: {
            show: true
          },
          y: {
            show: true
          }
        },
        legend: {
          position: 'bottom',
          padding: 16,
          show: false
        },
        size: this.chartBarWidth(key)
          ? { width: this.chartBarWidth(key), height: 500 }
          : { height: 500 }
      }
    },
    toAxisTick (value, step) {
      return Math.floor(Number(value) / step + 1e-8)
    },
    toChartAbsValue (value) {
      const n = Number(value)
      if (!isFinite(n)) return n
      return Math.abs(n)
    },
    measureChartViewport (key) {
      const el = this.$refs[CHART_SCROLL_REF[key]]
      if (el && el.clientWidth) {
        this.chartState[key].viewportWidth = el.clientWidth
      }
    },
    refreshChartSize (key) {
      if (key === 'dt3' && !this.showDt3Chart) return
      this.$nextTick(() => {
        this.measureChartViewport(key)
        this.$nextTick(() => {
          this.chartState[key].handler.$emit('init', this.barChartOptions(key))
        })
      })
    },
    refreshAllCharts () {
      this.refreshChartSize('dt1')
      this.refreshChartSize('dt2')
      if (this.showDt3Chart) {
        this.refreshChartSize('dt3')
      }
    },
    doSummary (key) {
      const state = this.chartState[key]
      state.barXaxisName = ['x']
      state.barXaxisValue = ['數量']
      const AllArray = []
      this.chartValueList(key).forEach((r) => {
        const n = this.toChartAbsValue(r)
        if (isFinite(n)) {
          AllArray.push(n)
        }
      })
      if (!AllArray.length) {
        state.barXaxisName.push('0')
        state.barXaxisValue.push(0)
        this.refreshChartSize(key)
        return
      }
      const step = Number(state.summaryRange)
      const minTick = this.toAxisTick(Math.min(...AllArray), step)
      const maxTick = this.toAxisTick(Math.max(...AllArray), step) + 1
      state.rangeMin = minTick * step
      state.rangeMax = maxTick * step
      const RangeArray = []
      for (let t = minTick; t < maxTick; t++) {
        RangeArray[t - minTick] = 0
      }
      const current = this.chartCurrentValue(key)
      const currentNum = current == null || current === '' ? null : this.toChartAbsValue(current)
      AllArray.forEach((r) => {
        let idx = this.toAxisTick(r, step) - minTick
        if (idx < 0) idx = 0
        if (idx >= RangeArray.length) idx = RangeArray.length - 1
        if (currentNum != null && isFinite(currentNum) && r === currentNum) {
          state.rangeIndex = idx
        }
        RangeArray[idx] = (RangeArray[idx] || 0) + 1
      })
      state.rangeCount = Math.max(...RangeArray)
      const decimals = state.summaryRange === '0.05' ? 2 : 1
      for (let i = 0; i < RangeArray.length; i++) {
        state.barXaxisValue.push(RangeArray[i] || 0)
        state.barXaxisName.push(
          ((minTick + i) * step).toFixed(decimals) + '-' +
          ((minTick + i + 1) * step).toFixed(decimals)
        )
      }
      this.refreshChartSize(key)
    },
    doSubmit (type) {
      this.loadingView = true
      const processType = this.$route.query.processType || ''
      const stationId = this.responseAreaData.stationId || ''
      const stage = this.summaryStage || this.$route.query.stage || ''
      let url = '/api/thermalModule/singleDeviceDataStatistic?pk=' + encodeURIComponent(this.summaryPk)
      if (processType) {
        url += '&processType=' + encodeURIComponent(processType)
      }
      if (stationId !== '' && stationId != null) {
        url += '&stationId=' + encodeURIComponent(stationId)
      }
      if (processType === 'VC' && stage && stage !== 'All') {
        url += '&stage=' + encodeURIComponent(stage)
      }
      this.$http.post(url).then(res => res.data)
        .then(res => {
          console.info(res)
          this.loadingView = false
          if (res.status !== 'success' || !res.data) {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = res.errMsg || ('查無此筆測資 (pk=' + this.summaryPk + ')')
            return
          }
          this.responseAreaData = this.normalizeResponseData(res.data)
          this.responseAreaData.warningColor = this.responseAreaData.testResult === 'pass' ? 'green' : 'red'
          this.responseAreaData.color = this.responseAreaData.testResult === 'pass' ? 'light-green' : 'pink'
          this.responseAreaData.icon = this.responseAreaData.testResult === 'pass' ? 'mdi-check' : 'mdi-alert'
          this.items = this.buildThermalItems(this.responseAreaData)
          this.doSummary('dt1')
          this.doSummary('dt2')
          this.$nextTick(() => {
            if (this.showDt3Chart) {
              this.doSummary('dt3')
            }
          })
        })
    },
    summaryList (Range) {
      if (Range.id === 'ModelName') {
        this.items = [
          {
            SN: 'DDDXXXX00' + Range.index,
            CPU: 83 + (Range.value * 5),
            CPUmax: 83 + (Range.value * 7),
            CPUmin: 83 + (Range.value * 2),
            GPU: 83 + (Range.value * 9),
            MESSAGE: 'fan error',
            TRY: Range.value
          }
        ]
      }
    }
  }
}
</script>
<style>
.chart-x-scroll {
  width: 100%;
  max-width: 100%;
}
.chart-x-inner {
  height: 500px;
}
.chart-x-inner .vuec3-chart,
.chart-x-inner .vuec3-chart svg {
  width: 100% !important;
  max-width: none !important;
}
</style>
